import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import { engine } from '@play-co/timestep-core';

interface CardsShineOpts extends ViewOpts {
  radius?: number;
}

export class CardsShine extends View {
  private image1: ImageScaleView;
  private image2: ImageScaleView;
  private autoUpdating = false;

  constructor(opts: CardsShineOpts) {
    super({
      width: 600,
      height: 600,
      centerOnOrigin: true,
      ...opts,
    });

    const radius = opts.radius || this.style.width * 0.5;

    this.image1 = new ImageScaleView({
      superview: this,
      image: 'assets/ui/cards/common/shine.png',
      scaleMethod: 'contain',
      width: radius * 2,
      height: radius * 2,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      opacity: 0.4,
    });

    this.image2 = new ImageScaleView({
      superview: this,
      image: 'assets/ui/cards/common/shine.png',
      scaleMethod: 'contain',
      width: radius * 2,
      height: radius * 2,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      centerOnOrigin: true,
      opacity: 0.4,
    });

    this.on('ViewRemoved', () => this.stopAutoUpdate());
  }

  public autoUpdate() {
    if (this.autoUpdating) return;
    this.autoUpdating = true;
    engine.subscribe('Tick', this.update);
  }

  public stopAutoUpdate() {
    this.autoUpdating = false;
    engine.unsubscribe('Tick', this.update);
  }

  private update = () => {
    this.image1.style.r += 0.02;
    this.image2.style.r -= 0.01;
  };
}
